import {observer} from "mobx-react";
import {Container, ContainerButtons, ContainerInputs, Content, ContentButton} from "./styled";
import React from "react";
import HeaderConfiguration from "@dropDesk/presentation/components/headers/header_configuration";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import InputsPanelAdm from "src/presentation/pages/panel_adm/ui/painel_adm/input_search";
import {Divider} from "antd";
import {CompanyEntity} from "@dropDesk/domain/entities/company/company.entity";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import Field from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/fields/field";
import {PaymentSubscriptionStatus} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription.enum";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import ModalsPanelAdm from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/modals";
import {useBetween} from "use-between";
import {useModalPanelAdm} from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/modals/visible_modal";
import {ChatIntegrationConnectionEntity} from "@dropDesk/domain/entities/chat/chat_integration_connection.entity";
import PaymentsHistory from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {formatIsoDateToDDMMYYYY} from "@dropDesk/utils/helpers/date_helper";

const PanelADM = observer(
    ({
         loading,
         getCompany,
         search,
         onUpdate,
         company,
         userMain,
         removeCache,
         allowSubscriptionUpgrade,
         chatConnection,
         loadingTablePayments,
         tablePayments,
         getDataFromPagePayments,
         onClickDownloadInvoice,
         onClickExternallyPay,
         onClickRefundPay
     }: {
        loading: boolean,
        getCompany: () => Promise<void>,
        search?: string
        onUpdate: (search: string) => void,
        company?: CompanyEntity
        userMain?: UserEntity
        removeCache: () => Promise<void>
        allowSubscriptionUpgrade: () => Promise<void>
        chatConnection?: ChatIntegrationConnectionEntity
        loadingTablePayments: boolean;
        tablePayments: ListPaginationEntity<PaymentEntity>
        getDataFromPagePayments: (page: number) => void,
        onClickDownloadInvoice: (payment: PaymentEntity) => void
        onClickExternallyPay: (payment: PaymentEntity) => void
        onClickRefundPay: (payment: PaymentEntity) => void

    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const {
            setVisibleModalRemoveCache,
            setVisibleModalRefund,
            setVisibleModalExternallyPay,
            setVisibleModalAllowSubscriptionUpgrade
        } = useBetween(useModalPanelAdm);

        const statusColor = (status: PaymentSubscriptionStatus): string => {
            if (status === PaymentSubscriptionStatus.active) {
                return SharedColors.success;
            }
            if (status === PaymentSubscriptionStatus.canceled) {
                return SharedColors.textCancelStatus;
            }
            return colors.text;
        }

        const statusColorConnection = (chatConnection: ChatIntegrationConnectionEntity): string => {
            if (chatConnection.hasActiveConnection) {
                return SharedColors.success;
            }
            if (chatConnection.hasInactiveConnection) {
                return SharedColors.textCancelStatus;
            }
            return colors.text;
        }

        const textConnection = (chatConnection: ChatIntegrationConnectionEntity): string => {
            if (chatConnection.hasActiveConnection) {
                return 'Conectado';
            }
            if (chatConnection.hasInactiveConnection) {
                return 'Desconectado';
            }
            return chatConnection.status;
        }

        return (
            <Container heightShowingHeaderInfo={appController.heightShowingHeaderInfo}>
                <Content background={colors.onBackground} border={colors.border}>
                    <HeaderConfiguration
                        letter={"Painel ADM"}
                        disabled={loading}
                    />
                    <ContainerInputs>
                        <InputsPanelAdm
                            search={search}
                            onUpdate={onUpdate}
                            loading={loading}
                            getCompany={getCompany}
                        />
                        {company &&
                            <>
                                <Divider style={{
                                    color: colors.hint,
                                    borderColor: colors.border
                                }}>Dados da conta</Divider>
                                <Field title={'Empresa'} description={company.name}/>
                                <Field title={'CPF/CNPJ'} description={company.document}/>
                                {userMain &&
                                    <Field title={'Email conta principal'} description={userMain.email ?? ''}/>}
                                <Field title={'Plano'} description={company.newSubs.planName}/>
                                <Field title={'Próxima cobrança'} description={company.newSubs.nextDueDateDDMMYYYY}/>
                                <Field
                                    colorDescription={statusColor(company.newSubs.status!)}
                                    title={'Status versão'}
                                    description={company.newSubs.status ?? ''}
                                />
                                <Field title={'Valor plano'}
                                       description={company.newSubs.totalValue ? `R$ ${company.newSubs.totalValue.toString()}` : ''}/>
                                <Field title={'Segmento'} description={company.segment ?? ''}/>
                                <Field title={'Código referência'}
                                       description={company.uniqueCode ? company.uniqueCode.toString() : ''}/>
                                <Field title={'Autenticação de dois fatores'}
                                       description={company.useTwoFactorAuthenticator ? 'Sim' : 'Não'}/>
                                {company.createdAt && <Field title={'Conta criada em'}
                                                             description={formatIsoDateToDDMMYYYY(company.createdAt)}/>}
                                <Field title={'Id company'} description={company.id}/>
                                <ContainerButtons>
                                    <ContentButton>
                                        <ButtonMain
                                            height={35}
                                            borderColor={colors.text}
                                            widthPercentage={100}
                                            letterFontSize={16}
                                            disabled={loading}
                                            loading={loading}
                                            color={'transparent'}
                                            type={"submit"}
                                            letter={"Remover cache"}
                                            letterColor={colors.text}
                                            onClick={() => setVisibleModalRemoveCache(true)}
                                            style={{fontSize: 14}}
                                        />
                                    </ContentButton>
                                    <ContentButton style={{marginLeft: 10}}>
                                        <ButtonMain
                                            height={35}
                                            borderColor={colors.text}
                                            widthPercentage={100}
                                            letterFontSize={16}
                                            disabled={loading}
                                            loading={loading}
                                            color={'transparent'}
                                            type={"submit"}
                                            letter={"Permitir efetuar upgrade"}
                                            letterColor={colors.text}
                                            onClick={() => setVisibleModalAllowSubscriptionUpgrade(true)}
                                            style={{fontSize: 14}}
                                        />
                                    </ContentButton>

                                </ContainerButtons>
                            </>
                        }


                        {company &&
                            <><Divider style={{
                                color: colors.hint,
                                borderColor: colors.border
                            }}>Dados de pagamento</Divider>
                                {company.extraInfo?.paymentInfo?.billingInfoHolder.email &&
                                    <Field title={'Email faturamento'}
                                           description={company.extraInfo?.paymentInfo?.billingInfoHolder.email}/>}
                                {company.extraInfo?.paymentInfo?.billingInfoHolder.document &&
                                    <Field title={'CNPJ/CPF faturamento'}
                                           description={company.extraInfo?.paymentInfo?.billingInfoHolder.document}/>}
                                {company.extraInfo?.paymentInfo?.billingInfoHolder &&
                                    <Field title={'Receber nota fiscal'}
                                           description={company.extraInfo?.paymentInfo?.billingInfoHolder.receiveInvoices ? 'Sim' : 'Não'}/>}
                                {company.paymentMethod && <Field title={'Método de pagamento'}
                                                                 description={company.paymentMethod.paymentMethodLabelTranslate}/>}
                                <PaymentsHistory
                                    tablePayments={tablePayments}
                                    loading={loadingTablePayments}
                                    getDataFromPagePayments={getDataFromPagePayments}
                                    onClickDownloadInvoice={onClickDownloadInvoice}
                                    currentSubscription={company.newSubs}
                                    onClickExternallyPay={(payment) => setVisibleModalExternallyPay({
                                        visible: true,
                                        payment: payment
                                    })}
                                    onClickRefundPay={(payment) => setVisibleModalRefund({
                                        visible: true,
                                        payment: payment
                                    })}
                                />
                            </>

                        }

                        {chatConnection &&
                            <><Divider style={{
                                color: colors.hint,
                                borderColor: colors.border
                            }}>Dados do WhatsApp</Divider>
                                <Field colorDescription={statusColorConnection(chatConnection)} title={'Status'}
                                       description={textConnection(chatConnection)}/>
                                {chatConnection.numberConnected &&
                                    <Field title={'Número conectado'} description={chatConnection.numberConnected}/>}
                                {chatConnection.extraInfo?.lid &&
                                    <Field title={'lid'} description={chatConnection.extraInfo?.lid}/>}
                            </>}


                        <ModalsPanelAdm
                            loading={loading}
                            onRemoveCache={removeCache}
                            onExternallyPay={(payment) => onClickExternallyPay(payment)}
                            onRefundPay={(payment) => onClickRefundPay(payment)}
                            onAllowSubscriptionUpgrade={allowSubscriptionUpgrade}
                        />
                    </ContainerInputs>
                </Content>
            </Container>
        )
    })
export default PanelADM;
